import NextLink from 'next/link';
import { cn } from '../../../lib/utils';
import { isExternalLink } from '..';

/* ============================================================================
   Item do menu HORIZONTAL - visual novo.

   Este menu so aparece quando o usuario escolhe o outro layout no painel de
   aparencia (`themeLayout === 'vertical'` no template, nome invertido que nao foi
   trocado para nao invalidar o cookie de quem ja escolheu).

   Substitui `ListItemStyle` de ./style.js (MUI) por um botao/link em Tailwind.
   ============================================================================ */

const BASE =
  'inline-flex h-8 flex-none items-center gap-1.5 whitespace-nowrap rounded-md px-2.5 text-[12px] font-semibold transition-colors';

function Conteudo({ icon, title, temFilhos, open }) {
  return (
    <>
      {icon && <span className="grid h-[18px] w-[18px] flex-none place-items-center">{icon}</span>}
      <span className="truncate">{title}</span>
      {temFilhos && (
        <span className={cn('text-[10px] leading-none transition-transform', open && 'rotate-90')} aria-hidden>
          ▶
        </span>
      )}
    </>
  );
}

export function NavItemRoot({ item, active, open, onToggle }) {
  const { title, path, icon, children } = item;

  // Cor cheia no ativo, como no menu vertical: `/10` de um primary escuro sai
  // cinza na tela (ver o comentario em vertical/NavItem.jsx).
  const classes = cn(
    BASE,
    active ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-soft hover:text-ink'
  );

  if (children) {
    return (
      <button type="button" onClick={onToggle} className={classes} aria-expanded={open}>
        <Conteudo icon={icon} title={title} temFilhos open={open} />
      </button>
    );
  }

  if (isExternalLink(path)) {
    return (
      <a href={path} target="_blank" rel="noopener noreferrer" className={classes}>
        <Conteudo icon={icon} title={title} />
      </a>
    );
  }

  return (
    <NextLink href={path} className={classes}>
      <Conteudo icon={icon} title={title} />
    </NextLink>
  );
}

// ----------------------------------------------------------------------

export function NavItemSub({ item, active, aoNavegar }) {
  const { title, path, icon } = item;

  const classes = cn(
    'flex w-full items-center gap-2 rounded-md px-2.5 py-1.5 text-left text-[12px] transition-colors',
    active ? 'font-bold text-primary' : 'font-medium text-muted-foreground hover:bg-soft hover:text-ink'
  );

  if (isExternalLink(path)) {
    return (
      <a href={path} target="_blank" rel="noopener noreferrer" className={classes} onClick={aoNavegar}>
        <Conteudo icon={icon} title={title} />
      </a>
    );
  }

  return (
    <NextLink href={path} className={classes} onClick={aoNavegar}>
      <Conteudo icon={icon} title={title} />
    </NextLink>
  );
}
